/**
 * Store admin — quote detail (Commerce, M4).
 * @see prototype/store/admin/all.html#quotes-detail
 */
import { createFileRoute } from "@tanstack/react-router";
import { QuoteDetailPage } from "../../../../../../features/store/quotes/quote-detail-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/quotes/$quoteId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { quoteId } = Route.useParams();
  return <QuoteDetailPage quoteId={quoteId} />;
}
